const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "Köszönjük, hogy regisztrált!",
      content:
        "Kedves,<br/>Köszönjük, hogy regisztrált. Örömmel értesítjük, hogy a BRIDGESTONE PLUS regisztrációját átnéztük és jóváhagytuk.<br/>Reméljük, hogy a BRIDGESTONE PLUS sikert és értékes lehetőségeket nyújt Önnek, és várjuk a további együttműködést.<br/>Üdvözlettel,<br/>A BRIDGESTONE PLUS csapata",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Köszönjük, hogy regisztrált!",
      content:
        "Kedves,<br/>Köszönjük, hogy regisztrált. Örömmel értesítjük, hogy a BRIDGESTONE PLUS regisztrációját átnéztük és jóváhagytuk.<br/>Reméljük, hogy a BRIDGESTONE PLUS sikert és értékes lehetőségeket nyújt Önnek, és várjuk a további együttműködést.<br/>Üdvözlettel,<br/>A BRIDGESTONE PLUS csapata",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
  },
};

export default {
  messages,
};
